import React from "react";
import {useTranslation} from "react-i18next";
import {Control} from "react-redux-form";
import CustomInput from "../../../components/custom-input/custom-input";

export interface InputModeContainer {
    id: string;
}

export const InputModeContainer: React.FC<InputModeContainer> = (props) => {
    const { t } = useTranslation();
    return (
        <div className='default-row'>
            <div className='default-field'>
                <Control
                    model={props.id + ".reactionTime"}
                    component={CustomInput}
                    defaultValue='00:00'
                    label={t('reactionTime')}
                    id={props.id + '.reactionTime'} />
            </div>
            <div className='default-field'>
                <Control
                    model={props.id + ".holdingTime"}
                    component={CustomInput}
                    defaultValue='00:00'
                    label={t('holdingTime')}
                    id={props.id + '.holdingTime'} />
            </div>
        </div>
    )
}